import { Star, Quote } from "lucide-react";
import { useReveal } from "@/hooks/useReveal";
import { reviews, business } from "@/data/siteData";

export default function Reviews() {
  const ref = useReveal();
  return (
    <section
      id="reviews"
      ref={ref}
      data-testid="reviews-section"
      className="relative py-20 md:py-28 bg-[#EBE4D8]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-14">
          <div className="lg:col-span-7">
            <p className="reveal text-[11px] tracking-[0.32em] uppercase text-[#5A7365] mb-5">
              Loved on Google
            </p>
            <h2 className="reveal font-serif-display text-3xl sm:text-4xl lg:text-5xl text-[#132A1C] leading-[1.1] tracking-tight">
              {business.rating}<span className="text-[#D4A373]">★</span> from{" "}
              <span className="italic">{business.reviewsCount}</span> Google reviews.
            </h2>
            <p className="reveal mt-5 text-[#2C4C3B] text-base md:text-lg max-w-2xl leading-relaxed">
              Loved for the cozy atmosphere, Vietnamese iced coffee, pho, banh mi,
              and the kind of friendly service that makes a small café feel like home.
            </p>
          </div>
          <div className="lg:col-span-5 lg:text-right">
            <div className="reveal inline-flex items-center gap-2" aria-label={`${business.rating} out of 5 stars`}>
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  size={22}
                  strokeWidth={1.5}
                  className="fill-[#D4A373] text-[#D4A373]"
                />
              ))}
              <span className="ml-3 font-serif-display text-2xl text-[#132A1C]">
                {business.rating} / 5
              </span>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((r, i) => (
            <figure
              key={i}
              data-testid={`review-card-${i}`}
              className="reveal bg-[#F4F0EA] border border-[#132A1C]/10 p-8 md:p-10 flex flex-col"
            >
              <Quote
                size={22}
                strokeWidth={1.5}
                className="text-[#D4A373] mb-5"
                aria-hidden
              />
              <blockquote className="font-serif-display text-xl md:text-[1.6rem] leading-snug text-[#132A1C]">
                “{r.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-5 border-t border-[#132A1C]/10 flex items-center justify-between">
                <span className="text-[11px] tracking-[0.2em] uppercase text-[#5A7365]">
                  {r.name}
                </span>
                <span className="flex gap-0.5" aria-hidden>
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star
                      key={s}
                      size={13}
                      strokeWidth={1.5}
                      className="fill-[#D4A373] text-[#D4A373]"
                    />
                  ))}
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
